import React from 'react';
import { FiArrowUp, FiArrowRight, FiArrowDown } from 'react-icons/fi';
import { statusBadgeTones } from '@/components/StatusBadge';

// Same options/values as the pages this replaces (AddTask.constants.js,
// AddUpdateTask.contants.js) — Priority stays P1-P4 to match the rest of
// the app (list view, filters, StatusBadge tone maps); only the visual
// treatment here is new.
export const STATUS_OPTIONS = [
  { value: 'TO DO', label: 'TO DO' },
  { value: 'IN PROGRESS', label: 'IN PROGRESS' },
  { value: 'QA', label: 'QA' },
  { value: 'DONE', label: 'DONE' },
];

export const PRIORITY_OPTIONS = [
  { value: 'P1', label: 'P1' },
  { value: 'P2', label: 'P2' },
  { value: 'P3', label: 'P3' },
  { value: 'P4', label: 'P4' },
];

// Same tone-per-priority mapping as src/views/Tasks/Tasks.config.jsx's
// PRIORITY_TONE, paired with an arrow direction so the Priority field's
// left icon reads as "how urgent" without introducing new colors.
export const PRIORITY_ARROW = {
  P1: { tone: statusBadgeTones.error, icon: <FiArrowUp size={14} /> },
  P2: { tone: statusBadgeTones.orange, icon: <FiArrowUp size={14} /> },
  P3: { tone: statusBadgeTones.purple, icon: <FiArrowRight size={14} /> },
  P4: { tone: statusBadgeTones.default, icon: <FiArrowDown size={14} /> },
};

export const PRIORITY_ARROW_COLOR = {
  [statusBadgeTones.error]: 'var(--error-600)',
  [statusBadgeTones.orange]: 'var(--orange-600)',
  [statusBadgeTones.purple]: 'var(--purple-600)',
  [statusBadgeTones.default]: 'var(--gray-500)',
};
